const WAP_USER_AGENT_PATTERN = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|Tablet|HarmonyOS/i
const VIWOODS_CLOUD_HOSTNAME = 'cloud.viwoods.com'

export function isWapClient () {
  if (typeof navigator === 'undefined') {
    return false
  }

  const userAgent = navigator.userAgent || ''
  const isIpadDesktopMode = /Macintosh/i.test(userAgent) && navigator.maxTouchPoints > 1

  return WAP_USER_AGENT_PATTERN.test(userAgent) || isIpadDesktopMode
}

export function shouldShowMobileUnavailablePage () {
  if (typeof window === 'undefined') {
    return false
  }

  const hostname = window.location.hostname.toLowerCase()
  const isLocalPreview = ['localhost', '127.0.0.1'].includes(hostname) &&
    new URLSearchParams(window.location.search).has('preview-mobile-unavailable')

  return isLocalPreview || (isWapClient() && hostname === VIWOODS_CLOUD_HOSTNAME)
}
